<div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
  <div class="flex items-start justify-between gap-4">
    <div class="flex flex-col gap-1">
      <span class="text-lg font-bold">{{ task.data.partnerName }}</span>
      <span class="text-neutral-500">{{ task.data.integration }}</span>
    </div>
    <button
      class="btn btn-primary self-start"
      type="button"
      (click)="openPartnerOfferings()"
    >
      {{ "task.action.viewPartnerOfferings" | translate }}
    </button>
  </div>

  <div class="flex flex-col gap-3">
    <h4>
      {{ "task.label.orphanedOfferings" | translate }}
      ({{ task.data.offerings.length }})
    </h4>
    <ul class="flex flex-wrap gap-2">
      @for (offering of task.data.offerings; track offering.id) {
        <li class="flex min-w-[200px] basis-[calc(25%-0.375rem)] flex-col gap-1 rounded-md border border-neutral-100 bg-neutral-50 p-2">
          <span class="line-clamp-2 font-medium">{{ offering.name }}</span>
          <div class="flex flex-wrap gap-2 text-sm text-neutral-500">
            @if (offering.code) {
              <span>{{ "task.label.offeringCode" | translate }}: {{ offering.code }}</span>
            }
            @if (offering.externalCode) {
              <span>{{ "task.label.offeringExternalCode" | translate }}: {{ offering.externalCode }}</span>
            }
          </div>
        </li>
      }
    </ul>
  </div>
</div>
